var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.691 10.323h-.003c.016-.12.023-.24.022-.362L9.532 7.13c.015.033.028.066.045.098.247.488.624.867 1.068 1.117l-.002.002a2.664 2.664 0 0 1-1.31 4.987 2.667 2.667 0 0 1-2.642-3.01Zm3.559.01V11a.417.417 0 1 0 .833 0v-.667a.417.417 0 0 0-.833 0ZM8.917 9.167v.666a.417.417 0 1 0 .833 0v-.666a.417.417 0 0 0-.833 0Zm0 2.333v.667a.417.417 0 0 0 .833 0V11.5a.417.417 0 0 0-.833 0Zm-1.334-1.167V11a.417.417 0 1 0 .833 0v-.667a.417.417 0 0 0-.833 0Zm1.728-4.656c-.015.12-.023.241-.022.362L6.468 8.871c-.015-.033-.028-.066-.045-.098-.237-.47-.61-.859-1.068-1.117l.002-.001a2.665 2.665 0 0 1 1.31-4.988 2.667 2.667 0 0 1 2.643 3.01h.001Zm-3.561-.01V5a.417.417 0 1 0-.833 0v.667a.417.417 0 0 0 .833 0Zm1.333 1.166v-.666a.417.417 0 1 0-.833 0v.666a.417.417 0 1 0 .833 0Zm0-2.333v-.667a.417.417 0 0 0-.833 0V4.5a.417.417 0 1 0 .833 0Zm1.334 1.167V5a.417.417 0 1 0-.833 0v.667a.417.417 0 0 0 .833 0ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 15a7 7 0 0 0 5.262-11.614L9.532 7.13a2.655 2.655 0 0 1-.243-1.09l3.306-3.317a7 7 0 0 0-9.857 9.892l3.73-3.743c.161.353.24.723.242 1.09l-3.305 3.317A6.97 6.97 0 0 0 8 15Z",
    fill: "#0E111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuts);
export default __webpack_public_path__ + "static/media/nuts.e79fe500e58a4e0b2b94919b597a86e5.svg";
export { ForwardRef as ReactComponent };